import Quill from 'quill';
import { Mentionables } from '../interfaces/ui-quill-mention.interfaces';

/**
 * Introduced an alias to Quill.import function as quillImport.
 * WHY?
 * New angular compiler settings prevent the use of reserved keywords like import
 * as function name. The string parameter was misinterpreted as dependency.
 * Can this settings be changed?
 * Maybe. But I bet it is better to leave it as it is. Why use reserved keywords?
 */
const quillImport = Quill.import.bind(Quill);
const Embed = quillImport('blots/embed');

const escape = (chars): string =>
  chars.replace(
    /[&<>'"]/g,
    // prettier-ignore
    (tag: '&' | '<' | '>' | '\'' | '"') =>
      ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '\'': '&#39;',
        '"': '&quot;'
      }[tag])
  );

export class MentionBlot extends Embed {
  static readonly blotName: string = 'mention';
  static readonly tagName: string = 'span';
  static readonly className: string = 'mention';
  static readonly clickedEvent: string = 'MentionClickedEvent';

  static create(data: Mentionables) {
    // node stores the actual embed blot created by quill
    const node = super.create();
    // denotationChar stores the denotation character like '@' or '#' by default if no alternative html is provided
    const denotationChar = document.createElement('span');
    const content = document.createElement('span');
    const wrapper = document.createElement('span');
    denotationChar.className = 'ql-mention-denotation-char';
    wrapper.appendChild(denotationChar);
    wrapper.appendChild(content);
    node.appendChild(wrapper);

    content.innerHTML = data.value ? escape(data.value) : '';

    // either we use the provided alternative html or simply the denotationChar here
    denotationChar.innerHTML = data.blotAlternativeIconHtml || data.denotationChar;

    // tooltip when we hover on the blot
    content.title = data.blotTooltip ? escape(data?.blotTooltip) : '';
    if (data.blotClickable) {
      wrapper.className = 'mention-clickable';
    }
    if (data.blotCustomClasses) {
      wrapper.className += ' ' + data.blotCustomClasses;
    }
    wrapper.className += ' mention-wrapper';
    return MentionBlot.setDataValues(node, data);
  }

  // Set values to the dataset for the blot
  static setDataValues(element, data) {
    const domNode = element;
    Object.keys(data).forEach((key) => {
      domNode.dataset[key] = data[key];
    });
    return domNode;
  }

  // Get the dataset from the provided domNode
  static value(domNode) {
    return domNode.dataset;
  }

  constructor(domNode) {
    super(domNode);
    domNode.addEventListener('click', this.onClickHandler);
  }

  onClickHandler(e: MouseEvent) {
    const mentionData: Mentionables = MentionBlot.value(e.currentTarget);
    // if the clicked blot is clickable we trigger a custom event
    // As for why toString()? We got back blotClickable from a blot so it was converted into a string
    if (mentionData.blotClickable && mentionData.blotClickable.toString() === 'true') {
      const newEvent: CustomEvent<Partial<Mentionables>> = new CustomEvent<Partial<Mentionables>>(MentionBlot.clickedEvent, {
        bubbles: false,
        cancelable: true,
        detail: mentionData
      });
      window.dispatchEvent(newEvent);
    }
  }
}
